export enum MediaType {
  RADIO = 'Internet Radio',
  TRACK = 'Local Track',
}
